module.exports = "/assets/landing-rwx/how-it-works/step_1@3x.png?GxPFoZO";